// Theme configuration:
export const MuiChip = {
    styleOverrides: {
        root: {
            fontSize: "13px", fontWeight: 400, lineHeight: "18px", letterSpacing: "0.16px",
            "& .MuiChip-icon": {
                marginLeft: "8px"
            }
        },
        sizeSmall: {
            "& .MuiChip-icon": {
                height: "13px"
            }
        }
    }
};
//# sourceMappingURL=Chip.js.map